import { render, staticRenderFns } from "./digitalbase.vue?vue&type=template&id=c196dac2&scoped=true&"
import script from "./digitalbase.vue?vue&type=script&lang=js&"
export * from "./digitalbase.vue?vue&type=script&lang=js&"
import style0 from "./digitalbase.vue?vue&type=style&index=0&id=c196dac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c196dac2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VIcon,VImg,VRow})
